import React, { Component } from 'react';
import { Button, TextField, Typography, Checkbox, FormControlLabel } from '@material-ui/core';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import './SignUpPage.scss';
import { inject } from 'mobx-react';
import ErrorMessage from '../../components/ErrorMessage';

const Heading = styled.h1`
  margin-top: 0;
`;

const FormContainer = styled.div`
  max-width: 480px;
  width: 100%;
  background-color: #edf4ff;
  padding: 30px;
  border-radius: 5px;
`;

const FormField = styled(TextField)`
  width: 100%;
`;

const SignInLink = styled(Typography)`
  text-align: center;
  margin-top: 20px;
  color: #007bff;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

@inject('userStore', 'routerStore')
class SignUpPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      firstName: '',
      errorMessage: null,
      termsAccepted: false,
    };
  }

  // Helper function to validate email
  validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  submit = async () => {
    const { email, password, firstName, termsAccepted } = this.state;

    if(!firstName) {
      this.setState({ errorMessage: 'First name is required.' });
      return;
    }

    if (!email || !password) {
      this.setState({ errorMessage: 'Email and password are required.' });
      return;
    }

    if (!this.validateEmail(email)) {
      this.setState({ errorMessage: 'Please enter a valid email address.' });
      return;
    }

    if (!termsAccepted) {
      this.setState({ errorMessage: 'Please accept the terms and agreement.' });
      return;
    }

    try {
      await this.props.userStore.signup(email, password, firstName);
      window.location.hash = '/signin';
    } catch (error) {
      const errorMessage = (error.response && error.response.data && error.response.data.message) 
        || 'An error occurred during signup.';
      this.setState({ errorMessage });
    }
  };

  handleSignInRedirect = () => {
    window.location.hash = '/signin';
  };

  render() {
    const { errorMessage, termsAccepted } = this.state;

    return (
      <div className="fullscreen-wrapper">
        <FormContainer>
          <Heading>Join us!</Heading>
          <p>Start managing notes easily.</p>

          {errorMessage && <ErrorMessage message={errorMessage} />}
          <div>
            <FormField
              id="outlined-first-name"
              label="First Name"
              margin="dense"
              variant="outlined"
              required
              onChange={(e) => this.setState({ firstName: e.target.value })}
            />
          </div>
          <div>
            <FormField
              id="outlined-email"
              label="Email"
              margin="dense"
              variant="outlined"
              required
              onChange={(e) => this.setState({ email: e.target.value })}
            />
          </div>
          <div>
            <FormField
              id="outlined-password"
              label="Password"
              margin="dense"
              variant="outlined"
              type="password"
              required
              onChange={(e) => this.setState({ password: e.target.value })}
            />
          </div>
          <p>
            Passwords must contain at least 1 upper case letter, 1 lower case letter, and one number OR special character.
          </p>
          <hr />
          <FormControlLabel
            control={
              <Checkbox
                checked={termsAccepted}
                onChange={(e) => this.setState({ termsAccepted: e.target.checked })}
                color="primary"
              />
            }
            label={
              <Typography>
                I agree to the{' '}
                <Link to="/terms">
                  terms and conditions
                </Link>
              </Typography>
            }
          />
          <div>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={this.submit}
            >
              SIGN UP
            </Button>
          </div>
          <SignInLink onClick={this.handleSignInRedirect}>
            Already have an account? Sign in now!
          </SignInLink>
        </FormContainer>
      </div>
    );
  }
}

export default SignUpPage;
